<template>
    <!-- 分享赚钱（PC端） -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <div class="container-fluid mt-3">
            <div class="row shengse pb-2 mt-2">
                <div class="dixian px-3 py-2 d-flex justify-content-between align-items-center">
                    <div class="lf">
                        <i class="bi bi-coin"></i>
                        分享赚钱
                    </div>
                </div>

                <!-- 主体：PC两栏布局（左文案 + 右侧“截图卡片”） -->
                <div class="p-0 gohome">
                    <div class="earn-layout">
                        <!-- 左侧：文案区 -->
                        <div class="earn-left">
                            <div class="content-card">
                                <h1>御凤楼7年老平台，提现秒到账，另支持多种结算方式,</h1>
                                <h1>推广链接以及二维码均做过特殊防封处理，长期有效，无需担心屏蔽问题！</h1>
                                <h1>随手一发~就能轻松赚钱！</h1>
                                <h1 style="margin-bottom: 1rem !important;">
                                    本站为VIP用户提供了 <a href="/Promotion">推广中心</a> 功能，
                                </h1>

                                <p>完全免费（不花钱就能成为代理）</p>
                                <p>不需要经验（所有的推广素材由本平台提供）</p>
                                <p>账务公开透明（可以在推广中心随时查看佣金）</p>
                                <p>结算方式多样化（支持微信/支付宝/银行卡/USDT）</p>

                                <h1>佣金收益介绍</h1>

                                <p class="commission-text">
                                    有任意用户通过您的二维码或推广链接在本平台开通任意会员您会获得50%的佣金收益。
                                </p>
                                <p class="commission-text">用户开通月会员，您将获得94元的佣金收益</p>
<!--                                <p class="commission-text">用户开通季度会员，您将获得100元的佣金收益</p>-->
                                <p class="commission-text">用户开通年会员，您将获得144元的佣金收益</p>
                                <p class="commission-text">用户开通永久至尊VIP 您将获得250元的佣金收益</p>
                                <p class="commission-text">佣金可以直接提现（24小时内到账）</p>

                                <p>右侧截图是某代理3天的佣金收益</p>
                                <p>只需动动手分享自己的链接 月入十万不是梦！</p>

                                <p style="margin-top: 10px !important;">
                                    可以在QQ群匿名发布自己的推广海报，也可以在微信群，微博等地方发您的推广链接或者推广二维码。
                                    其他的可以发挥自己的想象力去推广
                                </p>
                                <!-- 推广素材示例（放在说明文字下方） -->
                                <div class="promo-shot pc" style="margin: 15px 15px 0;">
                                    <img class="promo-shot__img" src="@/assets/promo_income2.jpg" alt="推广素材示例" />
                                </div>


                                <p class="commission-text2">成为御凤楼代理流程：</p>
                                <p class="commission-text3">
                                    注册账号后访问个人中心→我的推广→自动生成专属推广链接→有用户通过你的专属链接或者二维码开通会员即可获得50%的佣金！
                                </p>

                                <p class="commission-text4">
                                    另招募实力网推 地推 cpa cps seo团队，可以联系客服，提供专属短网址，以及推广扶持，
                                    让您推广更便捷！有意者请发邮件至客服邮箱：
                                </p>
                                <p>yufenglou321@gmail.com</p>
                            </div>
                        </div>

                        <!-- 右侧：图片区（PC端做成粘性侧栏 + 卡片） -->
                        <aside class="earn-right">
                            <div class="sticky">
                                <div class="shot-card">
                                    <div class="shot-title">收益示例截图</div>
                                    <div class="promo-shot pc">
                                        <img class="promo-shot__img" src="@/assets/promo_income.png" alt="佣金收益示例1" />
                                    </div>
                                </div>


                                <div class="shot-card">
                                    <div class="shot-title">更多展示</div>
                                    <div class="promo-shot pc">
                                        <img class="promo-shot__img" src="@/assets/promo_income3.png" alt="佣金收益示例3" />
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>

                    <!-- 移动端/窄屏时，右侧会自动下沉，这里不用额外写 -->
                </div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>
    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";

    export default {
        name: "PEarnbySharing",
        components: { ZhaiHeadPC, ZhaiFootPC }
    };
</script>

<style scoped>
    /* 基础 */
    .gongxi2 {
        height: 20px;
    }
    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    /* PC头部固定 */
    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        .errong {
            margin-top: 80px;
        }
    }

    /* 主布局：两栏 */
    .earn-layout {
        display: grid;
        grid-template-columns: 1fr 420px; /* 左自适应，右固定宽 */
        gap: 20px;
        padding: 16px;
    }

    /* 左侧文案卡片 */
    .content-card {
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.06);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        padding: 18px 10px;
    }

    /* 文本样式（PC稍大） */
    .gohome h1 {
        font-size: 1.1rem;
        margin-top: 1rem;
        color: #00c26f;
        padding-left: 15px;
        padding-right: 15px;
    }
    .gohome p {
        font-size: 1rem;
        color: #000;
        line-height: 1.8rem;
        padding-left: 15px;
        padding-right: 15px;
        margin: 0;
    }

    /* 佣金文字颜色 */
    .commission-text {
        color: #ff6d5f !important;
    }
    .commission-text2 {
        color: #ff6d5f !important;
        font-weight: bold;
        margin-top: 10px !important;
        margin-bottom: 0 !important;
    }
    .commission-text3 {
        color: #ff6d5f !important;
        font-weight: bold;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
    .commission-text4 {
        margin-top: 18px !important;
        margin-bottom: 0 !important;
        font-weight: bold;
    }

    /* 右侧：粘性侧栏 */
    .earn-right .sticky {
        position: sticky;
        top: 95px; /* 避开固定头部 */
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    /* 右侧卡片 */
    .shot-card {
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.06);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        padding: 12px;
    }
    .shot-title {
        font-size: 0.95rem;
        font-weight: 700;
        padding: 2px 2px 10px;
        color: #333;
    }

    /* 图片样式：PC端宽一些，像“截图卡片” */
    .promo-shot {
        display: flex;
        justify-content: center;
    }
    .promo-shot__img {
        width: 100%;
        border-radius: 6px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.10);
        border: 1px solid rgba(0, 0, 0, 0.06);
        display: block;
    }

    /* 宽屏再加一点空间感 */
    @media (min-width: 1200px) {
        .earn-layout {
            grid-template-columns: 1fr 460px;
            gap: 24px;
        }
        .content-card {
            padding: 22px 12px;
        }
    }

    /* 窄屏自动变成上下布局 */
    @media (max-width: 991px) {
        .earn-layout {
            grid-template-columns: 1fr;
        }
        .earn-right .sticky {
            position: static;
        }
    }
</style>
